import * as React from 'react'

interface ICheckboxGroupProps {
  required?: boolean
  name: string
  selectedValues: string[],
  onChange: (values: string[]) => void
  options: Array<{
    label: string
    value: string
  }>
  insertOtherOption?: boolean
}

interface ICheckboxGroupState {
  numOfChanges: number
  isOtherChecked: boolean
}

class CheckboxGroup extends React.Component<ICheckboxGroupProps, ICheckboxGroupState> {
  state = {
    numOfChanges: 0,
    isOtherChecked: false
  }

  previousOtherValue: string
  otherInput: HTMLInputElement

  componentDidMount() {
    let otherValue: string

    this.props.selectedValues.every((value) => {
      const found = this.props.options.some((option) => {
        return value === option.value
      })

      if (!found) {
        otherValue = value
        return false
      }

      return true
    })

    if (otherValue) {
      this.previousOtherValue = otherValue
      this.otherInput.value = otherValue

      this.setState({ isOtherChecked: true })
    }
  }

  update(e: React.ChangeEvent<HTMLInputElement>) {
    const w = e.currentTarget
    const value = w.value
    const wasAdded = w.checked
    const numOfChanges = this.state.numOfChanges++
    const selectedValues = [...this.props.selectedValues]
    // tslint:disable-next-line:no-console
    console.log('input update on ' + value + '. wasAdded: ' + wasAdded + ', checked? ' + w.checked)

    if (wasAdded) {
      selectedValues.push(value)
      // tslint:disable-next-line:no-console
      console.log('adding value: ' + value + ' leaving: ' + JSON.stringify(selectedValues))
    } else { //remove
      const index = selectedValues.indexOf(value)

      if (index >= 0) {
        selectedValues.splice(index, 1)
        // tslint:disable-next-line:no-console
        console.log('removed value: ' + value + ' leaving: ' + JSON.stringify(selectedValues))
      }
    }

    this.props.onChange(selectedValues)

    this.setState({ numOfChanges })
  }

  isChecked(value: string) {
    const r = this.props.selectedValues.indexOf(value) >= 0
    // tslint:disable-next-line:no-console
    console.log('isChecked of ' + value + '?: ' + r)
    return r
  }

  updateIsOtherChecked(e: React.ChangeEvent<HTMLInputElement>) {
    const isOtherChecked = e.currentTarget.checked

    if (!isOtherChecked) {
      const selectedValues = [...this.props.selectedValues]
      const index = selectedValues.indexOf(this.previousOtherValue)

      if (index >= 0) {
        selectedValues.splice(index, 1)
      }

      this.otherInput.value = ''
      this.previousOtherValue = undefined

      this.props.onChange(selectedValues)
    }

    this.setState({ isOtherChecked }, () => {
      if (isOtherChecked) {
        this.otherInput.focus()
      }
    })
  }

  updateOther(e: React.KeyboardEvent<HTMLInputElement>) {
    const { value } = e.currentTarget
    const numOfChanges = this.state.numOfChanges++
    const selectedValues = [...this.props.selectedValues]

    if (typeof this.previousOtherValue === 'string') {
      const index = selectedValues.indexOf(this.previousOtherValue)

      if (index >= 0) {
        selectedValues.splice(index, 1)
      }
    }

    selectedValues.push(value)
    this.previousOtherValue = value

    this.props.onChange(selectedValues)

    this.setState({ numOfChanges })
  }

  render() {
    // tslint:disable-next-line:no-console
    console.log('rendering...')
    return (
      <span>
        {this.props.options.map((option, index) =>
          <label key={option.value} style={{ display: 'block' }}>
            <input type="radio"
              name={this.props.name}
              value={option.value}
              checked={this.isChecked(option.value)}
              onChange={(e) => this.update(e)}
              required={this.props.required && index === 0}
            />&nbsp;&nbsp; {option.label}
          </label>
        )}
        {this.props.insertOtherOption ?
          <label>
            <input type="radio"
              name={this.props.name}
              checked={this.state.isOtherChecked}
              onChange={(e) => this.updateIsOtherChecked(e)}
            />&nbsp;&nbsp;Other
            <span style={{ visibility: this.state.isOtherChecked ? 'visible' : 'hidden' }}>
              :&nbsp;&nbsp;
              <input type="text"
                name={this.props.name + 'Other'}
                ref={(input) => this.otherInput = input}
                className="plain-input"
                placeholder="Please specify"
                onKeyUp={(e) => this.updateOther(e)}
                required={this.state.isOtherChecked} />
            </span>
          </label>
          : null
        }
      </span>
    )
  }
}

export {
  CheckboxGroup
}



// WEBPACK FOOTER //
// ./src/app/components/form/CheckboxGroup/index.tsx